<mat-dialog-content class="mat-typography">
    <iframe [src]="src"></iframe>
</mat-dialog-content>
<mat-dialog-actions align="end">
    <button mat-flat-button color="accent" mat-dialog-close>Fechar</button>
</mat-dialog-actions>